import { Typography } from "../../../components/util";
import AuthContainer from "../authContainer";
import AuthErrorFooter from "./authErrorFooter";

const InvitationCancelled = () => {
  return (
    <AuthContainer
      headerTitle="Invitation cancelled"
      footerContent={<AuthErrorFooter />}
      preventRedirect
    >
      <Typography paragraph styled={{ text: { shade: "weak" } }}>
        Your broker has cancelled the invitation. Contact your broker to get a
        new invitation.
      </Typography>
    </AuthContainer>
  );
};

export default InvitationCancelled;
